import React, { Component } from "react";
import { Link, NavLink } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import userAvatar from "../assets/img/img1.jpg";
import logo1 from "../assets/img/IMG-20250130-WA0008.jpg";
import '../assets/css/sidebar.css';
import {
    // dashboardMenu,
    rhMenu,
    caisseMenu,
    // ventesMenu,
    // achatsMenu,
    // stockMenu,
    // statistiquesMenu,
    parametresMenu,
    
} from "../data/Menu";
import { 
    ROLES, 
    ROLE_LABELS, 
    ROLE_COLORS, 
    MENU_PERMISSIONS,
    ROLE_PERMISSIONS
} from "../config/permissions";
import { API_BASE_URL } from "../constants/api";

export default class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: null,
            userRole: null,
            badges: {
                // stockCritique: 0,
                // facturesImpayees: 0,
                // commandesEnCours: 0,
                // contratsAlertes: 0
            },
            filteredMenus: {
                // dashboard: [],
                // ventes: [],
                // achats: [],
                // stock: [],
                // statistiques: [],
                parametres: [],
                rh: [],
                caisse: []
            }
        };
    }

    componentDidMount() {
        this.loadUser();
        this.fetchBadges();
        this.fetchContratAlerts();
    }

    // ✅ Charger l'utilisateur et son rôle
    loadUser = () => {
        try {
            const userStr = localStorage.getItem("user");
            console.log("Sidebar - userStr brut:", userStr);
            
            if (userStr && 
                userStr !== "undefined" && 
                userStr !== "null" && 
                userStr !== "{}" && 
                userStr.length > 2) {
                
                const userData = JSON.parse(userStr);
                
                if (userData && (userData.id_utilisateur || userData.id)) {
                    const userRole = userData.role || 'commercial';
                    this.setState({ 
                        user: userData,
                        userRole: userRole
                    }, () => {
                        console.log("✅ Sidebar - Utilisateur chargé:", userData);
                        console.log("✅ Sidebar - Rôle:", userRole);
                        this.filterMenusByRole();
                    });
                } else {
                    console.log("Sidebar - Utilisateur invalide (pas d'ID)");
                    localStorage.removeItem("user");
                    this.setState({ user: null, userRole: null });
                }
            } else {
                console.log("Sidebar - Aucun utilisateur valide trouvé");
                if (userStr === "undefined" || userStr === "null") {
                    localStorage.removeItem("user");
                }
                this.setState({ user: null, userRole: null });
            }
        } catch (error) {
            console.error("❌ Sidebar - Erreur de parsing:", error);
            localStorage.removeItem("user");
            this.setState({ user: null, userRole: null });
        }
    }

    // ✅ Vérifier si l'utilisateur a accès à un module
    hasAccess = (module, permission = 'view') => {
        const { userRole } = this.state;
        
        if (!userRole) return false;
        if (userRole === ROLES.ADMIN) return true;
        
        const rolePerms = ROLE_PERMISSIONS[userRole]?.[module] || [];
        const hasPermission = rolePerms.includes(permission);
        
        console.log(`🔍 Vérification accès - Rôle: ${userRole}, Module: ${module}, Permission: ${permission} => ${hasPermission ? '✅' : '❌'}`);
        
        return hasPermission;
    }

    // ✅ Filtrer les menus selon le rôle
    filterMenusByRole = () => {
        const { userRole } = this.state;
        
        if (!userRole) {
            console.log("❌ Aucun rôle trouvé, filtrage impossible");
            return;
        }

        console.log(`🔍 Filtrage des menus pour le rôle: ${userRole}`);

        const filterMenu = (menuItems, menuName) => {
            if (!menuItems) return [];
            if (userRole === ROLES.ADMIN) {
                console.log(`✅ Admin - Accès complet au menu ${menuName}`);
                return menuItems;
            }
            
            const filtered = menuItems.filter(item => {
                if (item.link) {
                    const routePerm = MENU_PERMISSIONS[item.link];
                    if (routePerm) {
                        const hasAccess = this.hasAccess(routePerm.module, routePerm.permission);
                        if (!hasAccess) {
                            console.log(`❌ Menu ${item.label} masqué pour ${userRole}`);
                            return false;
                        }
                    }
                }
                
                if (item.submenu) {
                    const filteredSubmenu = item.submenu.filter(subItem => {
                        if (!subItem.link) return true;
                        const routePerm = MENU_PERMISSIONS[subItem.link];
                        if (!routePerm) return true;
                        return this.hasAccess(routePerm.module, routePerm.permission);
                    });
                    
                    if (filteredSubmenu.length > 0) {
                        item.submenu = filteredSubmenu;
                        return true;
                    }
                    return false;
                }
                
                return true;
            });

            console.log(`📊 Menu ${menuName}: ${filtered.length} éléments après filtrage`);
            return filtered;
        };

        this.setState({
            filteredMenus: {
                // dashboard: filterMenu(dashboardMenu, 'dashboard'),
                // ventes: filterMenu(ventesMenu, 'ventes'),
                // achats: filterMenu(achatsMenu, 'achats'),
                // stock: filterMenu(stockMenu, 'stock'),
                // statistiques: filterMenu(statistiquesMenu, 'statistiques'),
                parametres: filterMenu(parametresMenu, 'parametres'),
                rh: filterMenu(rhMenu, 'rh'),
                caisse: filterMenu(caisseMenu, 'caisse')
            }
        }, () => {
            console.log("✅ Menus filtrés:", this.state.filteredMenus);
        });
    }

    // ✅ Récupérer les alertes de contrat
    fetchContratAlerts = async () => {
        try {
            const { user } = this.state;
            const userId = user?.id_utilisateur || user?.id;
            
            if (!userId) return;
            
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_BASE_URL}/contrats.php?action=alerts`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            
            if (response.ok) {
                const result = await response.json();
                if (result.success && result.data) {
                    const totalAlertes = (result.data.total_debut_proche || 0) + 
                                        (result.data.total_fin_proche || 0) + 
                                        (result.data.total_expires || 0);
                    this.setState(prevState => ({
                        badges: {
                            ...prevState.badges,
                            contratsAlertes: totalAlertes
                        }
                    }));
                }
            }
        } catch (error) {
            console.error("Erreur chargement alertes contrats:", error);
        }
    }

    fetchBadges = async () => {
        try {
            const { user } = this.state;
            const userId = user?.id_utilisateur || user?.id;
            
            if (!userId) {
                console.log("Sidebar - Pas d'utilisateur, badges non chargés");
                return;
            }
            
            const token = localStorage.getItem("token");
            const baseUrl = API_BASE_URL;
            
            // Récupérer le nombre de produits en stock critique
            try {
                const stockResponse = await fetch(
                    `${baseUrl}/stock_critique.php?action=statistiques&user_id=${userId}`,
                    { headers: { 'Authorization': `Bearer ${token}` } }
                );
                if (stockResponse.ok) {
                    const stockData = await stockResponse.json();
                    this.setState(prevState => ({
                        badges: {
                            ...prevState.badges,
                            stockCritique: (stockData.statistiques?.nb_ruptures || 0) + (stockData.statistiques?.nb_critiques || 0)
                        }
                    }));
                }
            } catch (error) {
                console.error("Erreur chargement stock critique", error);
            }

            // Récupérer le nombre de factures impayées
            try {
                const facturesResponse = await fetch(
                    `${API_BASE_URL}/factures_impayees.php?action=statistiques&user_id=${userId}`,
                    { headers: { 'Authorization': `Bearer ${token}` } }
                );
                if (facturesResponse.ok) {
                    const facturesData = await facturesResponse.json();
                    this.setState(prevState => ({
                        badges: {
                            ...prevState.badges,
                            facturesImpayees: facturesData.statistiques?.nb_factures_impayees || 0
                        }
                    }));
                }
            } catch (error) {
                console.error("Erreur chargement factures impayées", error);
            }

            // Récupérer le nombre de commandes en cours
            try {
                const commandesResponse = await fetch(
                    `${baseUrl}/commandes_cours.php?action=statistiques&user_id=${userId}`,
                    { headers: { 'Authorization': `Bearer ${token}` } }
                );
                if (commandesResponse.ok) {
                    const commandesData = await commandesResponse.json();
                    this.setState(prevState => ({
                        badges: {
                            ...prevState.badges,
                            commandesEnCours: (commandesData.statistiques?.nb_commandes_fournisseurs || 0) + 
                                            (commandesData.statistiques?.nb_commandes_clients || 0)
                        }
                    }));
                }
            } catch (error) {
                console.error("Erreur chargement commandes en cours", error);
            }
        } catch (error) {
            console.error("Erreur lors du chargement des badges", error);
        }
    }

    toggleFooterMenu = (e) => {
        e.preventDefault();
        let parent = e.target.closest(".sidebar");
        if (parent) {
            parent.classList.toggle("footer-menu-show");
        }
    }

    handleLogout = (e) => {
        e.preventDefault();
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        console.log("Sidebar - Déconnexion");
        window.location.href = "/pages/signin2";
    }

    getUserInitials = () => {
        const { user } = this.state;
        if (!user) return 'U';
        
        const prenom = user.prenom || user.prenom_utilisateur || '';
        const nom = user.nom || user.nom_utilisateur || '';
        
        const initialPrenom = prenom ? prenom.charAt(0).toUpperCase() : '';
        const initialNom = nom ? nom.charAt(0).toUpperCase() : '';
        
        return initialPrenom + initialNom || 'U';
    }

    getUserFullName = () => {
        const { user } = this.state;
        if (!user) return 'Invité';
        
        const prenom = user.prenom || user.prenom_utilisateur || '';
        const nom = user.nom || user.nom_utilisateur || '';
        
        return (prenom + ' ' + nom).trim() || 'Utilisateur';
    }

    getUserRole = () => {
        const { user } = this.state;
        if (!user || !user.role) return 'Visiteur';
        
        const roles = {
            'admin': 'Administrateur',
            'gestionnaire': 'Gestionnaire',
            'commercial': 'Commercial',
            'magasinier': 'Magasinier'
        };
        
        return roles[user.role] || user.role;
    }

    getRoleBadgeColor = () => {
        const { userRole } = this.state;
        const colors = {
            [ROLES.ADMIN]: 'danger',
            [ROLES.GESTIONNAIRE]: 'warning',
            [ROLES.COMMERCIAL]: 'info',
            [ROLES.MAGASINIER]: 'success'
        };
        return colors[userRole] || 'secondary';
    }

    render() {
        const { user, badges, filteredMenus } = this.state;

        return (
            <div className="sidebar">
                <div className="sidebar-header d-flex align-items-center justify-content-center">
                    <Link to="/" className="sidebar-logo">
                        <div className="logo-container">
                            <img src={logo1} alt="GEOTECH" className="logo-img" />
                        </div>
                    </Link>
                </div>
                <PerfectScrollbar className="sidebar-body" ref={ref => this._scrollBarRef = ref}>
                    <SidebarMenu 
                        onUpdateSize={() => this._scrollBarRef && this._scrollBarRef.updateScroll()}
                        badges={badges}
                        filteredMenus={filteredMenus}
                    />
                    <br></br>
                </PerfectScrollbar>
                <div className="sidebar-footer">
                    <div className="sidebar-footer-top">
                        <div className="sidebar-footer-thumb">
                            {user ? (
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '50%',
                                    backgroundColor: '#3EA436',
                                    color: 'white',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                    textTransform: 'uppercase'
                                }}>
                                    {this.getUserInitials()}
                                </div>
                            ) : (
                                <img src={userAvatar} alt="Avatar" />
                            )}
                        </div>
                        <div className="sidebar-footer-body">
                            <h6><Link to="/pages/profile">{this.getUserFullName()}</Link></h6>
                            <p>
                                <span className={`badge bg-${this.getRoleBadgeColor()} me-2`}>
                                    {this.getUserRole()}
                                </span>
                            </p>
                        </div>
                        <Link onClick={this.toggleFooterMenu} to="#" className="dropdown-link">
                            <i className="ri-arrow-down-s-line"></i>
                        </Link>
                    </div>
                    <div className="sidebar-footer-menu">
                        <nav className="nav">
                            <Link to="/pages/edit-profile">
                                <i className="ri-edit-2-line"></i> Modifier profil
                            </Link>
                            <Link to="/pages/profile">
                                <i className="ri-profile-line"></i> Voir profil
                            </Link>
                        </nav>
                        <hr />
                        <br></br><br></br><br></br><br></br>
                     
                        <nav className="nav">
                            {/* <Link to="/pages/aide">
                                <i className="ri-question-line"></i> Centre d'aide
                            </Link> */}
                            
                            <Link to="/pages/edit-profile">
                                <i className="ri-user-settings-line"></i> Paramètres
                            </Link>
                            <Link to="#" onClick={this.handleLogout}>
                                <i className="ri-logout-box-r-line"></i> Déconnexion
                            </Link>
                        </nav>
                    </div>
                </div>
            </div>
        )
    }
}

class SidebarMenu extends Component {
    toggleSubMenu = (e) => {
        e.preventDefault();

        let parent = e.target.closest('.nav-item');
        if (!parent) return;
        
        let node = parent.parentNode?.firstChild;

        while (node) {
            if (node !== parent && node.nodeType === Node.ELEMENT_NODE)
                node.classList.remove('show');
            node = node.nextElementSibling || node.nextSibling;
        }

        parent.classList.toggle('show');

        if (this.props.onUpdateSize) {
            this.props.onUpdateSize();
        }
    }

    toggleMenu = (e) => {
        e.preventDefault();

        let parent = e.target.closest('.nav-group');
        if (parent) {
            parent.classList.toggle('show');

            if (this.props.onUpdateSize) {
                this.props.onUpdateSize();
            }
        }
    }

    enhanceDashboardMenu = (menuItems) => {
        const { badges } = this.props;
        
        return menuItems.map(item => {
            const newItem = { ...item };
            
            if (item.label === "Stock critique" && badges.stockCritique > 0) {
                newItem.badge = badges.stockCritique;
                newItem.badgeColor = "danger";
            }
            else if (item.label === "Factures impayées" && badges.facturesImpayees > 0) {
                newItem.badge = badges.facturesImpayees;
                newItem.badgeColor = "danger";
            }
            else if (item.label === "Commandes en cours" && badges.commandesEnCours > 0) {
                newItem.badge = badges.commandesEnCours;
                newItem.badgeColor = "warning";
            }
            
            return newItem;
        });
    }

    populateMenu = (menuItems, isDashboard = false) => {
        if (!menuItems || !Array.isArray(menuItems)) return null;

        const itemsToRender = isDashboard ? this.enhanceDashboardMenu(menuItems) : menuItems;

        const menu = itemsToRender.map((item, key) => {
            let submenuItems;
            if (item.submenu && Array.isArray(item.submenu)) {
                submenuItems = item.submenu.map((subItem, subKey) => {
                    return (
                        <NavLink 
                            to={subItem.link} 
                            className="nav-sub-link text-muted" 
                            key={subKey}
                            onClick={() => this.props.onUpdateSize && this.props.onUpdateSize()}
                        >
                            {subItem.label}
                        </NavLink>
                    )
                });
            }

            return (
                <li key={key} className="nav-item">
                    {(!submenuItems) ? (
                        <NavLink 
                            to={item.link} 
                            className="nav-link"
                            onClick={() => this.props.onUpdateSize && this.props.onUpdateSize()}
                        >
                            <i className={item.icon}></i> 
                            <span>{item.label}</span>
                            {item.badge && (
                                <span className={`badge badge-${item.badgeColor || 'danger'} ms-auto`}>
                                    {item.badge}
                                </span>
                            )}
                        </NavLink>
                    ) : (
                        <div onClick={this.toggleSubMenu} className="nav-link has-sub">
                            <i className={item.icon} ></i> 
                            <span>{item.label}</span>
                            {item.badge && (
                                <span className={`badge badge-${item.badgeColor || 'danger'} ms-auto`}>
                                    {item.badge}
                                </span>
                            )}
                        </div>
                    )}
                    {item.submenu && <nav className="nav nav-sub">{submenuItems}</nav>}
                </li>
            )
        });

        return (
            <ul className="nav nav-sidebar">
                {menu}
            </ul>
        );
    }

    render() {
        const { filteredMenus } = this.props;

        console.log("🎯 SidebarMenu - Menus filtrés reçus:", filteredMenus);

        return (
            <React.Fragment>
                {/* Tableau de bord */}
                {filteredMenus?.dashboard && filteredMenus.dashboard.length > 0 && (
                    <></>
                    // <div className="nav-group show">
                    //     <div className="nav-label" onClick={this.toggleMenu}>
                    //         <i className="ri-dashboard-line" style={{marginRight:'5px'}}></i>
                    //         <span>Tableau de bord</span>
                    //     </div>
                    //     {this.populateMenu(filteredMenus.dashboard, true)}
                    // </div>
                )}


                {/* Caisse (Nouveau) */}
                {filteredMenus?.caisse && filteredMenus.caisse.length > 0 && (
                    <div className="nav-group show">
                        <div className="nav-label" onClick={this.toggleMenu}>
                            <i className="ri-bank-card-line" style={{marginRight:'5px'}}></i>
                            <span>Gestion de caisse</span>
                        </div>
                        {this.populateMenu(filteredMenus.caisse)}
                    </div>
                )}




                 {/* RH - Ressources Humaines (Nouveau) */}
                {filteredMenus?.rh && filteredMenus.rh.length > 0 && (
                    <div className="nav-group show">
                        <div className="nav-label" onClick={this.toggleMenu}>
                            <i className="ri-group-line" style={{marginRight:'5px'}}></i>
                            <span>Ressources Humaines</span>
                            {this.props.badges?.contratsAlertes > 0 && (
                                <span className="badge badge-danger ms-auto">
                                    {this.props.badges.contratsAlertes}
                                </span>
                            )}
                        </div>
                        {this.populateMenu(filteredMenus.rh)}
                    </div>
                )}

                



                {/* Ventes */}
                {filteredMenus?.ventes && filteredMenus.ventes.length > 0 && (
                    <></>
                    // <div className="nav-group show">
                    //     <div className="nav-label" onClick={this.toggleMenu}>
                    //         <i className="ri-shopping-bag-3-line" style={{marginRight:'5px'}}></i>
                    //         <span>Ventes</span>
                    //     </div>
                    //     {this.populateMenu(filteredMenus.ventes)}
                    // </div>
                )}

                {/* Achats */}
                {filteredMenus?.achats && filteredMenus.achats.length > 0 && (
                    <></>
                    // <div className="nav-group show">
                    //     <div className="nav-label" onClick={this.toggleMenu}>
                    //         <i className="ri-shopping-cart-line" style={{marginRight:'5px'}}></i>
                    //         <span>Achats</span>
                    //     </div>
                    //     {this.populateMenu(filteredMenus.achats)}
                    // </div>
                )}

                {/* Stock */}
                {filteredMenus?.stock && filteredMenus.stock.length > 0 && (
                    <></>
                    // <div className="nav-group show">
                    //     <div className="nav-label" onClick={this.toggleMenu}>
                    //         <i className="ri-hard-drive-2-line" style={{marginRight:'5px'}}></i>
                    //         <span>Stock</span>
                    //     </div>
                    //     {this.populateMenu(filteredMenus.stock)}
                    // </div>
                )}

               
                {/* Statistiques */}
                {filteredMenus?.statistiques && filteredMenus.statistiques.length > 0 && (
                    <></>
                    // <div className="nav-group show">
                    //     <div className="nav-label" onClick={this.toggleMenu}>
                    //         <i className="ri-bar-chart-2-line" style={{marginRight:'5px'}}></i>
                    //         <span>Statistiques</span>
                    //     </div>
                    //     {this.populateMenu(filteredMenus.statistiques)}
                    // </div>
                )}

                {/* Paramètres */}
                {filteredMenus?.parametres && filteredMenus.parametres.length > 0 && (
                    <div className="nav-group show">
                        <div className="nav-label" onClick={this.toggleMenu}>
                            <i className="ri-settings-3-line" style={{marginRight:'5px'}}></i>
                            <span>Paramètres</span>
                        </div>
                        {this.populateMenu(filteredMenus.parametres)}
                    </div>
                )}
            </React.Fragment>
        )
    }
}

// Event listeners
window.addEventListener("click", function (e) {
    let tar = e.target;
    let sidebar = document.querySelector(".sidebar");
    if (!tar.closest(".sidebar-footer") && sidebar) {
        sidebar.classList.remove("footer-menu-show");
    }
   
    if (!tar.closest(".sidebar") && !tar.closest(".menu-link")) {
        let body = document.querySelector("body");
        if (body) {
            body.classList.remove("sidebar-show");
        }
    }
});

window.addEventListener("load", function () {
    let skinMode = localStorage.getItem("sidebar-skin");
    let HTMLTag = document.querySelector("html");

    if (skinMode) {
        HTMLTag.setAttribute("data-sidebar", skinMode);
    }
});